import React, { useEffect, useState } from 'react';
import { projectFirestore } from '../firebase/config';
import useVisitorStats from '../hooks/useVisitorStats';

const GlobalVisitorCounter = () => {
  const [enabled, setEnabled] = useState(true);
  const [loadingSetting, setLoadingSetting] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const { loading, onlineVisitors, totalVisitors } = useVisitorStats();

  useEffect(() => {
    const unsub = projectFirestore.collection('settings').doc('site').onSnapshot((doc) => {
      if (doc.exists) {
        const data = doc.data();
        setEnabled(data.showGlobalVisitorCounter !== false);
      } else {
        setEnabled(true);
      }
      setLoadingSetting(false);
    }, () => {
      setEnabled(true);
      setLoadingSetting(false);
    });
    return () => unsub();
  }, []);

  if (loadingSetting || !enabled) return null;

  return (
    <>
      <button
        className="visitor-fab-btn"
        onClick={() => setShowTooltip((v) => !v)}
        aria-label="عدد الزوار"
        title="عدد الزوار"
      >
        <i className="fas fa-users" />
        {!loading && <span className="visitor-fab-badge">{onlineVisitors}</span>}
      </button>

      {showTooltip && (
        <div className="visitor-tooltip" onClick={() => setShowTooltip(false)}>
          <div className="visitor-tooltip-row">
            <i className="fas fa-circle text-success me-2" style={{ fontSize: 10 }} />
            <span>متصل الآن</span>
            <strong className="me-auto">{loading ? '...' : onlineVisitors}</strong>
          </div>
          <div className="visitor-tooltip-row">
            <i className="fas fa-globe me-2 text-primary" style={{ fontSize: 12 }} />
            <span>إجمالي الزوار</span>
            <strong className="me-auto">{loading ? '...' : totalVisitors}</strong>
          </div>
        </div>
      )}
    </>
  );
};

export default GlobalVisitorCounter;
